/** Legacy fixed width of the Reviews + Documents right rail (pre-resize fallback). */
export const PROJECT_RAIL_WIDTH_PX = 380;

/** Default split for feed/chats main column vs right rail (percentages). */
export const FEED_RAIL_DEFAULT: number[] = [72, 28];

/** Minimum sizes for feed vs right rail (percentages). */
export const FEED_RAIL_MINS: number[] = [45, 18];

/** Minimum container width before mounting percentage-based resize groups. */
export const RESIZE_LAYOUT_MIN_WIDTH_PX = 768;

/** Narrow-viewport fallback width for the review-mode chat column. */
export const REVIEW_CHAT_FALLBACK_PX = 280;

/** Narrow-viewport fallback width for the review-mode context column. */
export const REVIEW_CONTEXT_FALLBACK_PX = 320;

/** Minimum floor width for the artwork column in review fallback layout. */
export const REVIEW_ARTWORK_MIN_PX = 480;

/** Width of the collapsed chat/context expand rails. */
export const REVIEW_COLLAPSED_RAIL_PX = 32;

/** Minimum width before artwork + context use the resizable PanelGroup. */
export const REVIEW_ARTWORK_CONTEXT_PANEL_MIN_PX =
  REVIEW_ARTWORK_MIN_PX + REVIEW_CONTEXT_FALLBACK_PX;

/**
 * Inline min-width for the review workspace row: fill the viewport on wide
 * screens, but grow past it (triggering horizontal scroll) when panes need
 * more room. Plain pixel minWidth would override w-full and leave a white
 * gutter on the right at wide viewports.
 */
export function reviewWorkspaceRowStyle(minContentPx: number): {
  minWidth: string;
} {
  return { minWidth: `max(100%, ${minContentPx}px)` };
}

/**
 * Sum of visible panel floor widths for the review-mode workspace row.
 * Used to set `minWidth` on the horizontal scroll inner row so overflow
 * activates predictably instead of silently clipping.
 */
export function reviewWorkspaceMinWidth(opts: {
  chatCollapsed: boolean;
  contextCollapsed: boolean;
  hasContext: boolean;
}): number {
  const chatWidth = opts.chatCollapsed
    ? REVIEW_COLLAPSED_RAIL_PX
    : REVIEW_CHAT_FALLBACK_PX;
  const contextWidth =
    opts.hasContext && !opts.contextCollapsed
      ? REVIEW_CONTEXT_FALLBACK_PX
      : opts.hasContext && opts.contextCollapsed
        ? REVIEW_COLLAPSED_RAIL_PX
        : 0;
  return chatWidth + REVIEW_ARTWORK_MIN_PX + contextWidth;
}
